import React, { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'

import { Subtitle } from '../LabelValue/styles'
import { ILabelValueLocalProps } from './LabelValueLocal.types'
import { LabelCard, Title } from './styles'

const LabelValueLocal: FunctionComponent<ILabelValueLocalProps> = ({
  title,
  subtitle,
  value,
  icon: IconValue,
}) => {
  return (
    <LabelCard>
      <Grid container>
        <Title>{title}</Title>

        <Grid container>
          <Grid item style={{ paddingRight: 5 }}>
            <IconValue style={{ width: 16, height: 16, color: colors.blue }} />
          </Grid>
          <Grid item>
            <Subtitle>{subtitle}</Subtitle>
          </Grid>
          <Grid container>
            <Grid item style={{ marginLeft: 20 }}>
              <Subtitle>{value}</Subtitle>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </LabelCard>
  )
}

export default LabelValueLocal
